import _ from "lodash";
import React, { ChangeEvent } from "react";
import { FreshpaintIcon } from "../../../components/icons/themes/logos";
import { RightIcon } from "../../../components/icons/themes/windows10";
import { DestinationDefinition } from "../../../destinations/destinations";
import { DestinationStandardMappingItemNamed } from "../../../destinations/types";

const PropertyMappingInput: React.FC<{
    destinationPropertyKey: string;
    changeHandler: (e: ChangeEvent<HTMLInputElement>) => void;
    value: string;
}> = ({ destinationPropertyKey, changeHandler, value }) => {
    return (
        <div className="flex justify-between mb-1 items-center">
            <div className="w-1/3 flex-grow-0 flex-shrink-0 font-mono">
                <input onChange={changeHandler}
                       value={value}
                       placeholder="Property Key"
                       className="py-2 px-1 border border-white hover:border-gray-300 rounded"/>
            </div>
            <div className="w-1/3 flex-grow-0 flex-shrink-0 text-center">
                <RightIcon className="text-md"/>
            </div>
            <div className="w-1/3 flex-grow-0 flex-shrink-0"><code>{destinationPropertyKey}</code></div>
        </div>
    );
};

export const NewTransformationPageStep3: React.FC<{
    selectedDestinationStandardEvent: DestinationStandardMappingItemNamed;
    selectedDestinationDefinition: DestinationDefinition;
    setPropertyMapping: (properties: Record<string, string>) => void;
    propertyMapping: Record<string, string>;
}> = ({
    selectedDestinationStandardEvent,
    selectedDestinationDefinition,
    propertyMapping,
    setPropertyMapping,
}) => {
    const SelectedDestinationIcon = selectedDestinationDefinition.logoSquare;

    if (Object.keys(propertyMapping).length === 0){
        return null;
    }

    const orderedStandardEventProps = _.map(selectedDestinationStandardEvent.propertiesArr, (p) => p.key);

    return (
        <div className="flex justify-center">
            <div className="w-1/3 flex flex-col justify-between">
                <div className="border pt-4 px-4 pb-1 rounded">
                    <div className="mb-1 text-lg font-bold text-gray-700">Property Mapping</div>
                    <div className="text-sm text-gray-600 mb-4">
                        Set up a mapping of properties from Freshpaint to {selectedDestinationDefinition.name}.
                    </div>
                    <div className="w-full border-t mt-2 mb-4 border-color-gray-300"/>

                    <div className="flex justify-between mb-2">
                        <div className="w-1/3">
                            <FreshpaintIcon/>
                        </div>
                        <div className="w-1/3 text-center"/>
                        <div className="w-1/3">
                            <SelectedDestinationIcon/>
                        </div>
                    </div>
                    <>
                        {_.map(orderedStandardEventProps, (key) => {
                            const val = propertyMapping[key];
                            const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
                                setPropertyMapping({ ...propertyMapping, [key]: e.target.value });
                            };
                            return <PropertyMappingInput key={key} value={val} destinationPropertyKey={key}
                                                         changeHandler={changeHandler}/>;
                        })}
                    </>
                </div>
            </div>
        </div>
    );
};